import React, { useEffect, useRef, useState } from 'react'
import { l, TextInputV2, isMobile } from '@manychat/manyui'

import FlowTextEditor from 'common/builder/components/misc/FlowTextEditor'
import { useBuilderState } from 'common/builder/hooks/useBuilderState'
import { ButtonMaxCaptionLength } from 'common/builder/models/Button/constants'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'
import { IMinimalChangeEventHandler } from 'constants/constants'

interface IButtonTitleInputProps {
  builderId: string
  value: string
  onChange: IMinimalChangeEventHandler
  disabled?: boolean
  disabledTooltip?: string
  errors: Array<{ prop: string }>
  showErrors: boolean
  withVariables?: boolean
}

const ButtonTitleInput = (props: IButtonTitleInputProps) => {
  const { builderId, value, onChange, disabled, disabledTooltip, withVariables = true } = props
  const { errors, showErrors } = props

  const handleChange: IMinimalChangeEventHandler = (e) => {
    onChange(e)
  }

  const { config } = useBuilderState(builderId) ?? {}

  const hasVariables = !config?.disableContentPersonalization && withVariables

  const captionInput = useRef<IMCTextEditorRef>(null)
  const [captionDirty, setCaptionDirty] = useState(false)
  const handleCaptionBlur = () => setCaptionDirty(true)

  const captionError = errors.find((err) => err.prop === 'caption') && (showErrors || captionDirty)

  useEffect(() => {
    if (disabled) return
    const focusTimer = setTimeout(() =>
      isMobile ? captionInput?.current?.focus() : captionInput?.current?.select(),
    )
    return () => {
      clearTimeout(focusTimer)
    }
  }, [disabled])

  return (
    <>
      <label className="form-label">{l.translate('Button title')}</label>
      {disabled ? (
        <TextInputV2
          value={value}
          data-at="top"
          data-title={disabledTooltip || null}
          disabled
          ariaLabel={l.translate('Button title')}
        />
      ) : (
        <FlowTextEditor
          multiline={false}
          limit={ButtonMaxCaptionLength}
          ref={captionInput}
          name="caption"
          onChange={handleChange}
          onBlur={handleCaptionBlur}
          value={value}
          placeholder={l.translate('Enter title...')}
          isValid={!captionError}
          withVariables={hasVariables}
          withDefaultStyles
          data-onboarding-id="button-form-caption-editor"
        />
      )}
    </>
  )
}

export default ButtonTitleInput
